import { get, httpDelete, patch, post, put } from '../../utils/http';

export const fetchFields = ({ accountId }) => get(`/accounts/${accountId}/fields`);

export const addField = ({ accountId, ...params }) => post(`/accounts/${accountId}/fields`, params);

export const updateField = ({ accountId, fieldId, ...params }) =>
  patch(`/accounts/${accountId}/fields/${fieldId}`, params);

export const sortFields = ({ accountId, fields }) => put(`/accounts/${accountId}/fields/sort`, { fields });

export const deleteField = ({ accountId, fieldId }) => httpDelete(`/accounts/${accountId}/fields/${fieldId}`);
